import { useSelector } from 'react-redux';

import { selectors as ProfileSelectors } from '@palette/state/Profile';

export const useProfile = () => useSelector(ProfileSelectors.profile);
